import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type NoWildcardActionsForServicesConfig = typeof NoWildcardActionsForServicesConfig._.Config;

export const NoWildcardActionsForServicesConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.NoWildcardActionsForServices,
  configSchema: z.object({}),
});
